import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { IconSnackBarComponent } from './templates/icon-snack-bar/icon-snack-bar.component';

/**
 * @deprecated all future components and services for the /form-builder or forms page 
 * should be created under the FormsModule /dashboard/src/app/forms
 */
@NgModule({
  declarations: [
    IconSnackBarComponent
  ],
  imports: [
    CommonModule,
    HttpClientModule
  ],
  exports: []
})
export class FormContractModule {}
